import axios from "axios";
import { useEffect, useState } from "react";
import {
  ARCHIVE_CUSTOM_FIELD,
  DELETE_CUSTOM_FIELD,
  GET_CAMPAIGN_CUSTOM_FIELDS,
  GET_CUSTOM_FIELD_ANSWER_BY_ENTITY,
  GET_DONOR_CUSTOM_FIELDS,
  GET_ENTITY_FIELDS,
} from "../../../../constants/custom-field-endpoint";
import { useForm } from "react-hook-form";

export function useCustomFields(props) {
  const [customFields, setCustomFields] = useState([]);
  const [attachedFields, setAttachedFields] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [requestLoader, setRequestLoader] = useState(false);
  const [archiveErrorMessage, setArchiveErrorMessage] = useState("");
  const { register, watch } = useForm({defaultValues:{
    field_is_delete: '0',
    field_type: ""
  }});
  const filters = watch();

  const getCustomFields = (entity_id) => {
    setRequestLoader(true);
    axios
      .get(`${GET_CAMPAIGN_CUSTOM_FIELDS}${entity_id}?field_type=${filters?.field_type ? filters?.field_type : ''}&field_is_delete=${filters?.field_is_delete === '0' ? false : true}`)
      .then((res) => {
        setRequestLoader(false);
        if (res?.data?.status) {
          setCustomFields(res?.data?.response?.custom_fields);
          setAttachedFields(res?.data?.response?.attached_fields);
        } else {
          setCustomFields([]);
          setAttachedFields([]);
        }
      })
      .catch((error) => {
        setRequestLoader(false);
      });
  };

  const getEntityFields = (entity_id) => {
    setRequestLoader(true);
    axios
      .get(`${GET_ENTITY_FIELDS}${entity_id}`)
      .then((res) => {
        setRequestLoader(false);
        if (res?.data?.status) {
          setCustomFields(res?.data?.response);
        } else {
          setCustomFields([]);
        }
      })
      .catch((error) => {
        setRequestLoader(false);
      });
  };

  const getDonorCustomField = (donor_id) => {
    setRequestLoader(true);
    axios
      .get(`${GET_DONOR_CUSTOM_FIELDS}${donor_id}?field_type=${filters?.field_type ? filters?.field_type : ''}&field_is_delete=${filters?.field_is_delete === '0' ? false : true}`)
      .then((res) => {
        setRequestLoader(false);
        if (res?.data?.status) {
          setCustomFields(res?.data?.response);
        } else {
          setCustomFields([]);
        }
      })
      .catch((error) => {
        setRequestLoader(false);
      });
  };

  const getCustomFieldAnswers = (transaction_id) => {
    setRequestLoader(true);
    axios
      .get(`${GET_CUSTOM_FIELD_ANSWER_BY_ENTITY}${transaction_id}`)
      .then((res) => {
        setRequestLoader(false);
        if (res?.data?.status) {
          setAnswers(res?.data?.response);
        } else {
          setAnswers([]);
        }
      })
      .catch((error) => {
        setRequestLoader(false);
      });
  };

  const deleteCustomField = (item, entity_id) => {
    setRequestLoader(true);
    setArchiveErrorMessage("");
    axios
      .patch(`${ARCHIVE_CUSTOM_FIELD}${item?.id}/${item?.field_is_delete ? false : true}`)
      .then((res) => {
        setRequestLoader(false);
        if (res?.data?.status) {
          if(item?.entity_type === 'donor'){
            getDonorCustomField(entity_id);
          }else{
            getCustomFields(entity_id);
          }
          
        } else {
          setArchiveErrorMessage(res?.data?.message);
        }
      })
      .catch((error) => {
        setRequestLoader(false);
        setArchiveErrorMessage("Failed to archive a field");
      });
  };

  return {
    customFields,
    setCustomFields,
    getCustomFields,
    archiveErrorMessage,
    requestLoader,
    filters,
    register,
    answers,
    register,
    deleteCustomField,
    attachedFields,
    getDonorCustomField,
    getEntityFields,
    getCustomFieldAnswers,
  };
}
